import { Link, LinkProps } from '@mui/material';


interface EmailLinkProps extends Omit<LinkProps, 'children'> {
    email: string;
}

export function EmailLink({ email, ...linkProps }: EmailLinkProps) {
    return (
        <Link
            href={`mailto:${email}`}
            {...linkProps}
        >
            {email}
        </Link>
    );
}
